import { WorkOrderStatusEnum, WorkOrderChangeStatusEnum, type BimChapterEnum } from 'gql/graphql';

import { useCallback, useMemo, useState } from 'react';

import { isBimChapter, isOtherBimChapter } from '../../../WorkOrder/types';

export enum BimWorkOrderChangeUploadModalName {
    Price = 'Price',
    Other = 'Other',
}

export const useBimWorkOrderUploadMenu = ({
    workOrderStatus,
    workOrderChangeStatus,
    chapter,
}: {
    workOrderStatus: WorkOrderStatusEnum | undefined;
    workOrderChangeStatus: WorkOrderChangeStatusEnum | undefined;
    chapter: BimChapterEnum | undefined;
}) => {
    const [openedModal, setOpenedModal] = useState<{ [key: string]: boolean }>({});

    const openModalByName = useCallback((modalName) => {
        setOpenedModal({ [modalName]: true });
    }, []);

    const closeModalsHandler = useCallback(() => {
        setOpenedModal({});
    }, []);

    const isPriceTable = useMemo(() => isBimChapter(chapter), [chapter]);
    const isOtherTable = useMemo(() => isOtherBimChapter(chapter), [chapter]);

    const isAddPriceBtnDisabled = useMemo(
        () =>
            workOrderStatus !== WorkOrderStatusEnum.InProgress ||
            workOrderChangeStatus !== WorkOrderChangeStatusEnum.OnFormation ||
            !isPriceTable,
        [isPriceTable, workOrderChangeStatus, workOrderStatus],
    );

    const isAddOtherBtnDisabled = useMemo(
        () =>
            workOrderStatus !== WorkOrderStatusEnum.InProgress ||
            workOrderChangeStatus !== WorkOrderChangeStatusEnum.OnFormation ||
            !isOtherTable,
        [isOtherTable, workOrderChangeStatus, workOrderStatus],
    );

    const menuItems = useMemo(
        () => [
            {
                label: 'Смету',
                action: () => {
                    openModalByName(BimWorkOrderChangeUploadModalName.Price);
                },
                disabled: isAddPriceBtnDisabled,
            },
            {
                label: 'Прочие',
                action: () => {
                    openModalByName(BimWorkOrderChangeUploadModalName.Other);
                },
                disabled: isAddOtherBtnDisabled,
            },
        ],
        [isAddOtherBtnDisabled, isAddPriceBtnDisabled, openModalByName],
    );

    return {
        menuItems,
        closeModalsHandler,
        openedModalType: openedModal,
    };
};
